import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Loader from "@componentsShared/Loader/Loader";
import useHelpers from "@hooks/useHelpers";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
var MoyasarPaymentProcessing = function MoyasarPaymentProcessing() {
  var _searchParams$get;
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var paymentStatus = (_searchParams$get = searchParams.get("status")) !== null && _searchParams$get !== void 0 ? _searchParams$get : searchParams.get("in_status");
  var paymentMessage = searchParams.get("message");
  var _useCheckoutOrder$que = useCheckoutOrder().queryParams,
    order_id = _useCheckoutOrder$que.order_id,
    post_id = _useCheckoutOrder$que.post_id;
  var handleNavigation = function handleNavigation() {
    if (paymentStatus === "paid") {
      return navigateTo("/payedsuccess?order_id=".concat(order_id, "&paymentMessage=").concat(paymentMessage, "&paymentStatus=").concat(paymentStatus));
    }
    navigateTo("/payedfailed?post_id=".concat(post_id, "&order_id=").concat(order_id, "&paymentMessage=").concat(paymentMessage, "&paymentStatus=").concat(paymentStatus));
  };
  useEffect(function () {
    handleNavigation();
  }, []);
  return /*#__PURE__*/React.createElement(Loader, null);
};
export default MoyasarPaymentProcessing;